import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { MyVaultCatalogType } from '@/types/myVaultTypes';

export const getMyVaultCatalogApi = (): Promise<ApiResponseType<MyVaultCatalogType>> => {
  return authApiService.GET('/my-vault/catalog/');
};
